import {
  Box,
  Card, CardBody, Flex,
  Spinner,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useSearchParams } from 'react-router-dom';
import useFormDraft from '../../helpers/useFormDraft';
import EditSidebar from '../../Components/Sidebar/EditSidebar';
import MainPanel from '../../Components/Layouts/MainPanel';
import ContentPanel from '../../Components/Layouts/ContentPanel';
import Editor from '../../Components/FormEditor/Editor/Editor';
import EditMenu from '../../Components/Sidebar/EditMenu';
import EndPage from '../../Components/EndPage';
import FormActions from '../../Components/FormActions';
import PublishForm from '../../Components/PublishForm';
import FormSetup from '../../Components/FormSetup';
import FormEditorSidebar from '../../Components/FormEditorSidebar/FormEditorSidebar';

const tabs = ['setup', 'field', 'end', 'actions', 'publish'];
const getIndex = (searchParams) => {
  const tab = searchParams.get('tab');
  if (!tab) return 1;
  const i = tabs.findIndex((t) => t === tab);
  return i < 0 ? 1 : i;
};
const EditFormPage = () => {
  const { data: form } = useFormDraft();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleTabChange = (i) => {
    searchParams.set('tab', tabs[i]);
    setSearchParams(searchParams);
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <Box>
        <Tabs size="xs" variant="unstyled" defaultIndex={getIndex(searchParams)} onChange={handleTabChange}>
          <EditSidebar name={form?.name} />
          <MainPanel>
            <ContentPanel>
              <Flex direction="column" w="calc(100% - 275px)" position="relative">
                <EditMenu />
                <Card>
                  <CardBody id="edit">
                    <TabPanels>
                      <TabPanel>
                        <FormSetup />
                      </TabPanel>
                      <TabPanel>
                        {form ? <Editor form={form} /> : (
                          <Flex justifyContent="center">
                            <Spinner
                              thickness="4px"
                              speed="0.65s"
                              emptyColor="gray.200"
                              color="blue.500"
                              size="xl"
                            />
                          </Flex>
                        )}
                      </TabPanel>
                      <TabPanel>
                        <EndPage />
                      </TabPanel>
                      <TabPanel>
                        {form && <FormActions actions={form?.schema?.actions} />}
                      </TabPanel>
                      <TabPanel>
                        <PublishForm />
                      </TabPanel>
                    </TabPanels>
                  </CardBody>
                </Card>
              </Flex>
              <FormEditorSidebar />
            </ContentPanel>
          </MainPanel>
        </Tabs>
      </Box>
    </DndProvider>
  );
};
export default EditFormPage;
